<template>

  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100">
        <!-- <img
          src="../assets/img/loginEsquerdo.png"
          alt=""
        >         -->
        <div class="login100-more">
          <img
            src="../assets/img/loginEsquerdo2.png"
            alt=""
          >
        </div>
        <div class="login100-form validate-form">

          <form class="form">
            <picture class="login100-form-title p-b-43">
              <source
                media="(max-width: 420px)"
                srcset="../assets/img/icone_transp.png"
                type="image/png"
              >
              <img
                src="../assets/img/LOGO_NOVO_aprovado_transp.png"
                alt="logo Church System"
              >
            </picture>

            <!-- Alerta de Primeiro Acesso -->
            <v-alert
              dense
              type="info"
              v-if="changePassword"
            >
              Esse é seu primeiro <strong>Primeiro Acesso</strong> coloque uma nova senha!
            </v-alert>

            <!-- Alert of access error -->
            <v-alert
              dense
              outlined
              type="error"
              v-if="invalidLogin"
            >
              {{ userInvalid }}
            </v-alert>

            <!-- Input E-mail -->
            <div v-if="!changePassword">
              <v-text-field
                prepend-icon="email"
                name="email"
                label="E-mail"
                type="email"
                :error-messages="emailErrors"
                :success="!$v.user.email.$invalid"
                v-model.trim="$v.user.email.$model"
                color="deep-purple lighten-1"
              >
              </v-text-field>
            </div>

            <div v-if="changePassword">
              <v-text-field
                prepend-icon="lock"
                name="newPass"
                label="Nova Senha"
                :type="showPassNew ? 'text' : 'password'"
                :error-messages="NewPassErrors"
                :success="!$v.changePass.newPass.$invalid"
                v-model.trim="$v.changePass.newPass.$model"
                color="deep-purple lighten-1"
                :append-icon="showPassNew ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassNew = !showPassNew"
              >
              </v-text-field>
            </div>
            <!-- Fim Input E-mail -->

            <!-- Input Senha -->
            <div class="input-password" v-if="!changePassword">
              <v-text-field
                prepend-icon="lock"
                name="Senha"
                label="Senha"
                :type="showPassLogin ? 'text' : 'password'"
                :error-messages="SenhaErrors"
                :success="!$v.user.Senha.$invalid"
                v-model.trim="$v.user.Senha.$model"
                color="deep-purple lighten-1"
                :append-icon="showPassLogin ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassLogin = !showPassLogin"
              >
              </v-text-field>
            </div>

            <div class="input-password" v-if="changePassword">
              <v-text-field
                prepend-icon="lock"
                name="confirmPass"
                label="Confirme a Senha"
                :type="showPassConfirm ? 'text' : 'password'"
                :error-messages="ConfirmPassErrors"
                :success="!$v.changePass.confirmPass.$invalid"
                v-model.trim="$v.changePass.confirmPass.$model"
                color="deep-purple lighten-1"
                :append-icon="showPassConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassConfirm = !showPassConfirm"
              >
              </v-text-field>
              <br>
              <span v-if="!senhasIguais">As senhas não coincidem.</span>
              <span v-if="msgPassNewOk">Senha alterada com sucesso.</span>
            </div>

            <!-- Fim Input E-Senha -->

            <!-- Botão Lembrar e Esqueceu a senha -->

            <div class="flex-sb-m w-full p-t-3 p-b-32">
              <div class="contact100-form-checkbox">
                <input
                  class="input-checkbox100"
                  id="ckb1"
                  type="checkbox"
                  name="remember-me"
                />
                <!-- <label
                  class="label-checkbox100"
                  for="ckb1"
                >
                  Lembrar-me
                </label> -->
              </div>

              <!-- <div>
                <a
                  href="#"
                  class="txt1"
                > Esqueceu a senha? </a>
              </div> -->
            </div>
            <!-- Fim botão Lembrar e Esqueceu a senha -->

            <!-- Botão Entrar -->
            <div class="container-login100-form-btn" v-if="!changePassword">
              <v-btn
                block
                depressed
                :loading="loading"
                color="deep-purple lighten-1 white--text"
                large
                @click="loader = 'loading'"
                class="login100-form-btn"
              >
                Entrar
              </v-btn>
            </div>

            <div class="container-login100-form-btn" v-if="changePassword">
              <v-btn
                block
                depressed
                color="deep-purple lighten-1 white--text"
                large
                @click="savePass"
                class="login100-form-btn"
              >
                Salvar
              </v-btn>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import '../assets/css/login.css'
import '../assets/css/util.css'

import '../assets/fonts/font-awesome-4.7.0/css/font-awesome.min.css'
import '../assets/fonts/Linearicons-Free-v1.0.0/icon-font.min.css'

import VueJwtDecode from 'vue-jwt-decode'
import Cookie from 'js-cookie'
import api from '../../../plugins/api'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  data: () => ({
    isLogin: true,
    loader: null,
    loading: false,
    user: {
      name: '',
      email: '',
      Senha: ''
    },
    changePass: {
      confirmPass: '',
      newPass: ''
    },
    userInvalid: '',
    invalidLogin: false,
    changePassword: false,
    senhasIguais: true,
    showPassLogin: false,
    showPassNew: false,
    showPassConfirm: false,
    msgPassNewOk: false
  }),
  validations () {
    const validations = {
      user: {
        email: {
          required,
          email
        },
        Senha: {
          required,
          minLength: minLength(8)
        }
      },
      changePass: {
        confirmPass: {
          required,
          minLength: minLength(8)
        },
        newPass: {
          required,
          minLength: minLength(8)
        }
      }
    }

    if (this.isLogin) { return validations }

    return {
      user: {
        ...validations.user,
        name: {
          required,
          minLength: minLength(3)
        }
      }
    }
  },
  // async created () {
  //   const getToken = Cookie.get('refreshToken')
  //   if (getToken) {
  //     await this.$router.push('/dashboard/home')
  //   }
  // },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      // setTimeout(() => (this[l] = false), 3000)
      setTimeout(() => (this.submit()), 3000)

      this.loader = null
    }
  },
  computed: {
    // texts () {
    //   return this.isLogin
    //     ? { toolbar: 'Entrar', button: 'Criar conta' }
    //     : { toolbar: 'Criar conta', button: 'Já tenho uma conta' }
    // },
    ConfirmPassErrors () {
      const errors = []
      const confirmPass = this.$v.changePass.confirmPass
      if (!confirmPass.$dirty) { return errors }
      !confirmPass.required && errors.push('Confirme Senha é obrigatório!')
      !confirmPass.minLength && errors.push(`Insira pelo menos ${confirmPass.$params.minLength.min} caracteres!`)
      return errors
    },
    NewPassErrors () {
      const errors = []
      const newPass = this.$v.changePass.newPass
      if (!newPass.$dirty) { return errors }
      !newPass.required && errors.push('Nova Senha é obrigatório!')
      !newPass.minLength && errors.push(`Insira pelo menos ${newPass.$params.minLength.min} caracteres!`)
      return errors
    },
    emailErrors () {
      const errors = []
      const email = this.$v.user.email
      if (!email.$dirty) { return errors }
      !email.required && errors.push('Email é obrigatório!')
      !email.email && errors.push('Insira um email válido!')
      return errors
    },
    SenhaErrors () {
      const errors = []
      const Senha = this.$v.user.Senha
      if (!Senha.$dirty) { return errors }
      !Senha.required && errors.push('Senha é obrigatória!')
      !Senha.minLength && errors.push(`Insira pelo menos ${Senha.$params.minLength.min} caracteres!`)
      return errors
    },
    compareSenhasIguais () {
      // return this.changePass.newPass === this.changePass.confirmPass
      return this.senhasIguais
    }
  },
  methods: {
    log () {
      // console.log('Vuelidate', this.$v)
    },
    clearFields () {
      this.user.email = ''
      this.user.Senha = ''
    },
    compararSenhas () {
      this.senhasIguais = this.changePass.newPass === this.changePass.confirmPass
    },
    submit () {
      api.post('usuario/login', this.user)
        .then((response) => {
          if (response.data.hasOwnProperty('value')) {
            const decriptToken = VueJwtDecode.decode(response.data.value.token)
            if (decriptToken.first_access === 'True') {
              Cookie.set('token', response.data.value.token, { expires: 0.1 })
              this.changePassword = true
              this.loader = null
              this.loading = false
              return
            }
          }

          this.$store.commit('pegaEmailUser', this.user.email)
          let getToken = Cookie.get('token')
          if (!getToken) {
            Cookie.set('token', response.data.token, { expires: 0.1 })
            Cookie.set('refreshToken', response.data.refreshToken, { expires: 0.1 })
            getToken = Cookie.get('token')
          }
          if (getToken) {
            this.loader = null
            this.loading = false
            const getToken = Cookie.get('token')
            const decriptToken = VueJwtDecode.decode(getToken)
            const menuParse = JSON.parse(decriptToken.menu)
            let redirectUrl = menuParse[0].link
            this.$router.push('/' + redirectUrl).catch(() => {})
          } else {
            this.loader = null
            this.loading = false
            this.$router.push('/')
          }
        }).catch((error) => {
          if (error.toString().indexOf('404') !== -1) {
            this.userInvalid = 'Seu Usuário ou Senha está inválido!'
            this.invalidLogin = true
            // this.clearFields()
            setTimeout(() => {
              this.loader = null
              this.invalidLogin = false
              this.loading = false
              this.user.email = ''
              this.user.Senha = ''
            }, 3000)
            this.loader = null
          } else {
            this.invalidLogin = false
            this.loading = false
          }
        })
    },
    savePass () {
      this.compararSenhas()
      if (this.senhasIguais === false) {
        return
      }
      const getObj = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getObj)
      let obj = {}
      obj.id = decriptToken.sub
      obj.email = decriptToken.email
      obj.password = this.changePass.newPass
      obj.confirmPassword = this.changePass.confirmPass
      obj.idchurch = Number(decriptToken.id_church)
      api.put('/usuario/newPass', obj).then((resp) => {
        this.showPassNew = false
        this.showPassConfirm = false
        this.msgPassNewOk = true
        setTimeout(() => (this.passChangeOk()), 4000)
        // this.changePassword = false
        Cookie.remove('token')
      }).catch((erro) => {
      })
    },
    passChangeOk () {
      this.changePass.confirmPass = ''
      this.changePass.newPass = ''
      this.user.Senha = ''
      this.changePassword = false
    }
  }
}
</script>

<style scoped>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
